import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import { Link, useLocation } from 'react-router-dom';
import { getAuth, signOut } from "firebase/auth";
import { Container, Form, Button, Image, Row, Col, Nav, NavDropdown, Modal } from 'react-bootstrap';
import { FiHome, FiFolder, FiCalendar, FiClock, FiFileText, FiUser, FiSettings, FiGrid, FiList, FiPieChart, FiLogOut, FiPlus, FiUsers, FiChevronLeft, FiChevronRight, FiMenu, FiX } from 'react-icons/fi';
import SalesPopup from './SalesPopup';

function SideNav() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    
    // Get collapse state from localStorage, default based on screen size
    const [isCollapsed, setIsCollapsed] = useState(() => {
        if (window.innerWidth <= 768) return true;
        const saved = localStorage.getItem('sidebarCollapsed');
        return saved !== null ? JSON.parse(saved) : true;
    });
    
    // For mobile: track if sidebar overlay is open
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    
    const location = useLocation();
    const userRole = window.localStorage.getItem('projectUserRole');
    const userDisplayName = window.localStorage.getItem('projectUserDisplayName');

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            if (mobile) {
                setIsCollapsed(true);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Close mobile menu when route changes
    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location.pathname]);

    // Prevent body scroll when mobile menu is open
    useEffect(() => {
        if (isMobileMenuOpen && isMobile) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isMobileMenuOpen, isMobile]);

    const handleLogout = () => {
        const auth = getAuth();
        signOut(auth).then(() => {
            window.localStorage.clear();
            window.location.href = '/login';
        }).catch((error) => {
            // An error happened.
        });
    }

    const toggleSidebar = () => {
        if (isMobile) {
            setIsMobileMenuOpen(!isMobileMenuOpen);
        } else {
            const newState = !isCollapsed;
            setIsCollapsed(newState);
            localStorage.setItem('sidebarCollapsed', JSON.stringify(newState));
        }
    };

    const menuItems = [
        // { name: userRole == 'preSales' ? 'Lead Form' : 'Dashboard', icon: FiGrid, path: '/', roles: ['admin', 'preSales', 'salesperson', 'designer', 'designerHead','production','qualityCheck','executionHead','siteMeasurement','projectManager'] },
        { name: 'Dashboard', icon: FiGrid, path: '/', roles: ["dataAnalyst", 'admin', 'salesHead', 'salesHeadBLRHRBR', 'salesHeadBLRKN', 'salesHeadKKTNT', 'preSales', 'preSalesTeamLead', 'salesperson', 'designer', 'designerHead','production','qualityCheck','executionHead','siteMeasurement','projectManager'] },
        { name: 'Leads', icon: FiGrid, path: '/leads', roles: [ 'preSales', 'preSalesTeamLead', 'admin', 'salesHead', 'salesHeadBLRHRBR', 'salesHeadBLRKN','salesHeadKKTNT', 'salesperson', 'admin', 'superAdmin'] },
        { name: 'Projects', icon: FiFolder, path: '/projects', roles: ['admin', 'salesHead', 'salesHeadBLRHRBR', 'salesHeadBLRKN', 'salesHeadKKTNT', 'salesperson', 'designer', 'designerHead','production','qualityCheck','executionHead','siteMeasurement','projectManager'] },
        { name: 'My Task', icon: FiList, path: '/my-task', roles: ['salesperson', 'designer', 'designerHead','production','qualityCheck','executionHead','siteMeasurement','projectManager'] },
        { name: 'Projects Overview', icon: FiPieChart, path: '/projects-overview', roles: ['admin', 'salesHead', 'salesHeadBLRHRBR', 'salesHeadBLRKN', 'salesHeadKKTNT', 'designerHead', 'superAdmin','executionHead'] },
        { name: 'Designers Overview', icon: FiUsers, path: '/designers-overview', roles: ['admin', 'designerHead', 'superAdmin'] },
        { name: 'Calendar', icon: FiCalendar, path: '/calendar', roles: ['admin', 'salesHead', 'salesHeadBLRHRBR', 'salesHeadBLRKN','salesHeadKKTNT', 'designerHead', 'superAdmin'] },
        { name: 'Sales Report', icon: FiPieChart, path: '/sales-report', roles: ["dataAnalyst", 'admin', 'salesHead', 'salesHeadBLRHRBR', 'salesHeadBLRKN','salesHeadKKTNT', 'designerHead', 'superAdmin'] },
        { name: 'Champions board', icon: FiPieChart, path: '/champions-board', roles: ["dataAnalyst", 'admin', 'salesHead', 'salesHeadBLRHRBR', 'salesHeadBLRKN', 'salesHeadKKTNT', 'designerHead', 'superAdmin'] },
    ]

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const handleOpenPopup = () => setIsPopupOpen(true);
    const handleClosePopup = () => setIsPopupOpen(false);
    
    const handleSubmit = (formData) => {
        console.log(formData);
        handleClosePopup();
    };

    return (
        <>
            {/* Mobile Top Bar */}
            {isMobile && (
                <div className="mobile-top-bar">
                    <button 
                        className="mobile-menu-btn" 
                        onClick={toggleSidebar}
                        aria-label="Toggle menu"
                    >
                        {isMobileMenuOpen ? <FiX /> : <FiMenu />}
                    </button>
                    <Image 
                        src={require('../assets/PDFlogo.png')} 
                        className="mobile-logo"
                        alt="Logo"
                    />
                    <div className="mobile-user-icon">
                        <FiUser />
                    </div>
                </div>
            )}

            {/* Overlay for mobile */}
            {isMobile && isMobileMenuOpen && (
                <div 
                    className="sidebar-overlay" 
                    onClick={() => setIsMobileMenuOpen(false)}
                />
            )}

            <div className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobile && isMobileMenuOpen ? 'mobile-open' : ''} ${isMobile ? 'mobile' : ''}`}>
                <div className="sidebar-header">
                    {!isCollapsed && !isMobile && (
                        <Image 
                            src={require('../assets/PDFlogo.png')} 
                            className="logo"
                            alt="Logo"
                        />
                    )}
                    {!isMobile && (
                        <button 
                            className="toggle-btn" 
                            onClick={toggleSidebar} 
                            title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                            aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                        >
                            {isCollapsed ? <FiChevronRight className="icon" /> : <FiChevronLeft className="icon" />}
                        </button>
                    )}
                </div>

                {userRole === "salesperson" && (
                    <button className="create-project-btn" onClick={() => handleOpenPopup()}>
                        <FiPlus className="icon" />
                        {(!isCollapsed || isMobileMenuOpen) && <span>Create Project</span>}
                    </button>
                )}

                <nav className="nav-menu">
                    <ul>
                        {menuItems
                            .filter((item) => item.roles.includes(userRole))
                            .map((item) => (
                                <li 
                                    key={item.name}
                                    className={
                                                location.pathname === item.path ||
                                                location.pathname.startsWith(item.path + '/')
                                                    ? 'active'
                                                    : ''
                                                }
                                    title={isCollapsed && !isMobileMenuOpen ? item.name : ''}
                                >
                                    <Link to={item.path}>
                                        <item.icon className="icon" />
                                        {(!isCollapsed || isMobileMenuOpen) && <span>{item.name}</span>}
                                    </Link>
                                </li>
                            ))
                        }
                    </ul>
                </nav>

                <div className="user-section">
                    <div className="user-info">
                        <FiUser className="user-icon" />
                        {(!isCollapsed || isMobileMenuOpen) && <span className="user-name">{userDisplayName?.slice(0, 10)}</span>}
                    </div>
                    <button className="logout-button" onClick={handleLogout}>
                        <FiLogOut className="logout-icon" />
                        {(!isCollapsed || isMobileMenuOpen) && <span>Logout</span>}
                    </button>
                </div>

                <SalesPopup 
                    isOpen={isPopupOpen} 
                    onClose={handleClosePopup} 
                    onSubmit={handleSubmit}
                />
            </div>
        </>
    )
}

export default SideNav